import { Dialog, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTostify } from '@sprytki-frontend-apps/common';
import { OrderItemsServiceAPI } from 'api/services/orderItemsServiceAPI';
import { alertStore } from 'stores/alertStore/alertStore';
import { appStore } from 'stores/appStore';
import { DualTitleDialog } from './DualTitleDialog';
import { observer } from 'mobx-react-lite';

interface ReleaseLockerDialogProps {
	open: boolean;
	onClose: () => void;
	lockerId: string;
	orderItemId?: string;
	userFriendlyId: string;
}

export const ReleaseLockerDialog = observer(
	({ open, onClose, orderItemId, lockerId, userFriendlyId }: ReleaseLockerDialogProps) => {
		const { t } = useTranslation();
		const toast = useTostify();

		const handleRelease = async () => {
			if (!orderItemId || appStore.isLoading) return;
			appStore.setIsLoading(true);
			try {
				const response = await OrderItemsServiceAPI.Release(orderItemId);
				if (response?.success === false) {
					toast(t('releaseDialog.error'), 'error');
					return;
				}
				alertStore.markLockerAsVerified(lockerId);
				toast(t('releaseDialog.success'), 'success');
				onClose();
			} catch (err) {
				toast(t('releaseDialog.error'), 'error');
			} finally {
				appStore.setIsLoading(false);
			}
		};

		return (
			<Dialog open={open} onClose={onClose}>
				<DualTitleDialog
					dialogTitle={t('releaseDialog.title')}
					dialogTitleSecondary={`${t('common.locker')}: ${userFriendlyId}`}
				/>
				<DialogContent>
					<DialogContentText>{t('releaseDialog.content')}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={onClose} disabled={appStore.isLoading} variant='outlined'>
						{t('releaseDialog.cancel')}
					</Button>
					<Button
						onClick={handleRelease}
						color='primary'
						variant='contained'
						disabled={!orderItemId || appStore.isLoading}
					>
						{t('releaseDialog.release')}
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
);
